// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import PropTypes from 'prop-types';

// Data
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

// Components
import ClearwaysGroupsMap from "pages/components/Map/ClearwaysMaps/Groups";
import StopmonitorMap from "pages/components/Map/StopmonitorMapView";

// API/MODELS
import bksAPI from "services/api/bks";

// Mapbox
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';

// helper
import { useSoftUIController } from "hooks/context";
import { processDevicesData } from "utils/device";
import { enableMap } from "utils/map";

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function MapView({ map, user }) {
    useEffect(() => {
        if (!map.current) return;

        enableMap(map);
        map.current.setPadding({ left: 0, right: 0, top: 0, bottom: 0 });
    }, []);

    bksAPI.loadToken(useAuth0());

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        }
    });

    if (devices.isLoading) {
        return ('Loading...');
    }

    if (devices.error) {
        var error = devices.error;
        return ("An error has occurred: " + error.message);
    }

    if (!devices.data) {
        return ('Loading...');
    }

    if (location.pathname.includes('stopmonitor')) {
        return <StopmonitorMap map={map} user={user} devices={processDevicesData(devices.data)} />;
    }
    else if (user.user.organisations.length > 1) {
        return <ClearwaysGroupsMap map={map} user={user} devices={devices.data} />;
    }

    // 2. Default path (/overview) for single-org users
    if (user.user.organisations.includes('clearways') && user.user.organisations.length === 1) {
        return <ClearwaysGroupsMap map={map} user={user} devices={devices.data} />;
    }

    // 3. All other cases (No clearways, or default stopmonitor)
    return <StopmonitorMap map={map} user={user} devices={processDevicesData(devices.data)} />;
}

MapView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default MapView;